import script from "./RightPart.vue?vue&type=script&setup=true&lang=js"
export * from "./RightPart.vue?vue&type=script&setup=true&lang=js"

import "./RightPart.vue?vue&type=style&index=0&id=70b8c114&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-70b8c114"]])

export default __exports__